import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import '../i18n'; // important to import
const Faq = () => {
        const { t } = useTranslation('faq');
    
    return (
        <>
            <section>
                <div className="faq-main position-relative">
                    <div className="container">
                        <div className="section-title col-md-12 col-lg-12 m-auto">
                            <span className="d-block text-start">{t("frequetlyaskedquestions")} </span>
                            <h2 className="text-start text-black display-6">{t("gotquestionswevegotanswers")} </h2>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Accordion className="accordion" defaultActiveKey="0">
                                    <Accordion.Item className='mb-4 border-0 rounded-3 px-3' eventKey="0">
                                        <Accordion.Header className="accordion-header">{t("howdoisignupforamnaccount")} </Accordion.Header>
                                        <Accordion.Body>
                                        <p className="text-muted fw-400">
                                           {t("accordiondes1")}
                                        </p>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item className='mb-4 border-0 rounded-3 px-3' eventKey="2">
                                            <Accordion.Header>{t("arethereanyfreecourseavailable")} </Accordion.Header>
                                            <Accordion.Body>
                                                <p className="text-muted fw-400">
                                                    {t("accordiondes2")}
                                                </p>
                                            </Accordion.Body>
                                    </Accordion.Item>

                                     <Accordion.Item className='mb-4 border-0 rounded-3 px-3' eventKey="3">
                                         <Accordion.Header>{t("caniacecessmycourseonmullipledevices")} </Accordion.Header>
                                         <Accordion.Body>
                                             <p className="text-muted fw-400">
                                                {t("accodiondes3")}
                                             </p>
                                         </Accordion.Body>
                                     </Accordion.Item>

                                     <Accordion.Item className='mb-4 border-0 rounded-3 px-3' eventKey="4">
                                         <Accordion.Header>{t("canidownloadcoursematerialsforifflineaccess")} </Accordion.Header>
                                         <Accordion.Body>
                                             <p className="text-muted fw-400">
                                                {t("accordiondes4")}
                                             </p>
                                         </Accordion.Body>
                                     </Accordion.Item>

                                     <Accordion.Item className='mb-4 border-0 rounded-3 px-3' eventKey="5">
                                         <Accordion.Header>{t("howlongdoihaveaccesstoacourseafterenrollment")} </Accordion.Header>
                                         <Accordion.Body>
                                             <p className="text-muted fw-400">
                                                {t("accordiondes5")}
                                             </p>
                                         </Accordion.Body>
                                     </Accordion.Item>

                                     <Accordion.Item className='mb-4 border-0 rounded-3 px-3' eventKey="6">
                                         <Accordion.Header>{t("canigetarefundifiamnotsatishfiedwithacourse")} </Accordion.Header>
                                         <Accordion.Body>
                                             <p className="text-muted fw-400">
                                                 {t("accordiondes6")}
                                             </p>
                                         </Accordion.Body>
                                     </Accordion.Item>

                                     <Accordion.Item className='mb-4 border-0 rounded-3 px-3' eventKey="7">
                                         <Accordion.Header>{t("arethecoursetaughtbyrealinstructors")} </Accordion.Header>
                                         <Accordion.Body>
                                             <p className="text-muted fw-400">
                                                 {t("accordiondes7")}
                                             </p>
                                         </Accordion.Body>
                                     </Accordion.Item>
                                </Accordion>
                                <div className="mt-5">
                                    <h4 className="text-black mb-4 fw-400 text-center text-md-start">{t("questionnotlistedhelp")} </h4>
                                    <p className="text-muted fw-400 text-center text-md-start">
                                       {t("wearehereassistdes1")}
                                       <Link to="" className="text-primary fw-400">{t("support@example.com")} </Link> 
                                       {t("wearehereassistdes2")}
                                    </p>
                                    <div className="d-md-flex mt-4">
                                        <Link to="/faq-questions" className="btn-primary fw-500 rounded-2 sm-w-100 bg-primary d-block position-relative">
                                           {t("gotoourfaqpage")}
                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none">
                                                <mask id="mask0_250_9685" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={24}>
                                                    <rect width={24} height={24} fill="#D9D9D9" />
                                                </mask>
                                                <g mask="url(#mask0_250_9685)">
                                                    <path d="M6.4 18L5 16.6L14.6 7H6V5H18V17H16V8.4L6.4 18Z" fill="white" />
                                                </g>
                                            </svg>
                                        </Link>
                                        <Link to="/community-help" className="btn-secondary text-primary fw-500 rounded-2 sm-w-100 mt-3 mt-md-0 bg-secondary d-block position-relative mx-0 mx-md-3">
                                           {t("visitourhelpcenter")}
                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none">
                                                <mask id="mask0_250_9690" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={24}>
                                                    <rect width={24} height={24} fill="#D9D9D9" />
                                                </mask>
                                                <g mask="url(#mask0_250_9690)">
                                                    <path d="M6.4 18L5 16.6L14.6 7H6V5H18V17H16V8.4L6.4 18Z" fill="#002FA7" />
                                                </g>
                                            </svg>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Faq;
